import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import { AccAttachmentRawDto } from '../../shared-acc-board-approval-module/_models/acc-attachment-raw-dto';
import { AccItemRawDto } from '../../shared-acc-board-approval-module/_models/acc-item-raw-dto';

export class AccProjectRawDto {
    communityId: number;
    customerId: string;
    accId: number;
    description: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    receivedDate: Date;

    assignedTo: string;

    @Type(() => AccAttachmentRawDto)
    projectAttachments: AccAttachmentRawDto[];

    @Type(() => AccItemRawDto)
    items: AccItemRawDto[];
}
